<!-- 查询车辆信息接口内容 -->
<template>
    <div class="">
        <right-structure :Pdatas='infoData'>
            <pre slot="q_code">{{JSON.stringify(requestBody, null, 4)}}</pre>
            <pre slot="r_code">{{JSON.stringify(responseCode, null, 4)}}</pre>
        </right-structure>
    </div>
</template>

<script>
import structure from "@/components/commonStructure.vue"

export default {
    name: '',
    components: {
        'right-structure': structure,
    },
    props:['commonUrls'],
    data() {
        return {
            requestBody: {
                "carNo": "粤Y12345",
                "pageNum": 1,
                "pageSize": 10
            },
            responseCode: {
                "data": {
                    "currCount": 1,
                    "recordList": [
                        {
                            "bingdingDate": "20190325145335",
                            "carNo": "粤Y12345",
                            "defaultCar": 1,
                            "id": 10,
                            "pushedMsgTotal": 0,
                            "status": 1,
                            "userId": 2998,
                            "authLevel": 1,
                            "phone": "13838380438"
                        }
                    ],
                    "total": 1
                }, "message": "业务成功", "resultCode": 0, "status": 1
            },
            infoData: {
                explain: "第三方接入系统请求智慧停车开放平台,查询车辆信息",
                t_url: this.commonUrls.test+"getCars",
                p_url: this.commonUrls.prod+"getCars",
                precondition: "无",
                fitSystem: "VEMS传统停车场，云停车场",
                pattern: "智慧停车开放平台提供接口, 第三方接入系统主动请求",
                Q_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'userId', info2: '否', info3: 'Long', info4: '用户id' },
                        { info1: 'carNo', info2: '否', info3: 'String', info4: '用户车牌号' },
                        { info1: 'pageNum', info2: '是', info3: 'Integer', info4: '第几页，从1开始' },
                        { info1: 'pageSize', info2: '是', info3: 'Integer', info4: '每页多少条，最多1000条' }
                        ]
                },],
                R_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'total', info2: '是', info3: 'Integer', info4: '记录总数' },
                        { info1: 'currCount', info2: '是', info3: 'Integer', info4: '当前获取的记录数' },
                        { info1: 'recordList', info2: '是', info3: 'String', info4: '用户信息列表' },
                        ]
                },{
                    titleName: 'recordList',
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'id', info2: '是', info3: 'Long', info4: 'id' },
                        { info1: 'userId', info2: '是', info3: 'Long', info4: '用户id' },
                        { info1: 'carNo', info2: '是', info3: 'String', info4: '车牌号' },
                        { info1: 'bingdingDate', info2: '是', info3: 'String', info4: '绑定时间，yyyyMMddHHmmss' },
                        { info1: 'authDate', info2: '是', info3: 'String', info4: '认证时间，yyyyMMddHHmmss' },
                        { info1: 'status', info2: '是', info3: 'Integer', info4: '状态，0绑定 1删除 2认证 3被他人认证' },
                        { info1: 'defaultCar', info2: '是', info3: 'Integer', info4: '缺省车牌，0否 1是' },
                        { info1: 'pushMsgTotal', info2: '是', info3: 'Integer', info4: '推送微信进出场消息总次数' },
                        { info1: 'authLevel', info2: '是', info3: 'Integer', info4: '认证级别：0未认证，1缴费认证，2行驶证认证，3实名认证' },
                        { info1: 'phone', info2: '是', info3: 'String', info4: '手机号码' },
                        ]
                }],
                codeStatus: [{
                    titleName: null,
                    tabledata: [{ tableHead: '状态码', tdName: 'info1' }, { tableHead: '说明', tdName: 'info2' }],
                    td: [{ info1: '000110', info2: '失败', }, { info1: '00110000', info2: '失败', }, { info1: '110000', info2: '失败', }]
                }],
            }
        }
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
// @import "../../assets/less/conmon.less";
</style>



// WEBPACK FOOTER //
// src/components/Doc/urbanOperation/ydtUser/getCars.vue